var _clipPath, _clipPath2, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 753.6 545.3",
    viewBox: "0 0 753.6 545.3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m231.7 206h470.3v247h-470.3z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m231.7 206h470.3v247h-470.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h753.6v108.4l-19.5 18.3v-107.2h-714.6v506.2h714.6v-51.2l19.5 19.3v51.5h-753.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "m319.7 391.3c0-34 28-61.7 62.4-61.7s62.4 27.7 62.4 61.7-28.1 61.7-62.5 61.7c-34.3 0-62.3-27.7-62.3-61.7m97 0c0-19.4-14.9-35.5-34.7-35.5s-34.7 16.2-34.7 35.5c0 19.4 14.9 35.5 34.7 35.5s34.7-16.1 34.7-35.5"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "m260.7 402.8h-.3v50.3h-28.6v-122.8h47.3c20.1 0 36.6 16.3 36.6 36.2 0 15.3-9.5 28.5-23.8 34l40.1 52.5h-33.1zm15.2-23.2c7.5 0 12.8-5.3 12.8-12s-5.4-12.2-12.8-12.2h-15.6v24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "m447.6 391.3c0-34 28-61.7 62.4-61.7s62.4 27.7 62.4 61.7-28 61.7-62.4 61.7-62.4-27.7-62.4-61.7m97 0c0-19.4-14.9-35.5-34.7-35.5s-34.7 16.2-34.7 35.5c0 19.4 14.9 35.5 34.7 35.5s34.7-16.1 34.7-35.5"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "m579.2 328.9 61.4 61 61.4-61v124.2h-27.8v-60.6l-33.6 33.3-33.7-33.3v60.6h-27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "m231.7 206.7h42.7c18.6 0 33.8 15.2 33.8 33.8 0 8-3 14.6-8 19.5 9.6 5.1 16 14.4 16 26.6 0 18.7-15.2 33.8-34.4 33.8h-50.1zm39.8 45.9c6.9 0 11.8-5 11.8-11.2s-5-11.4-11.8-11.4h-14.2v22.6zm7.8 44.2c6.9 0 11.8-5 11.8-11.2s-5-11.4-11.8-11.4h-22.1v22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "m323.9 206.7h25.6v113.6h-25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "m357.3 263.5c0-31.7 25.8-57.5 57.5-57.5 19.3 0 34.5 7.8 45.5 21.2l-19.2 15.7c-6.8-8.6-14.3-12.5-26.3-12.5-18.2 0-32 15-32 33.1s13.8 33.1 32 33.1c9.2 0 16.2-1.6 21.7-5.5v-15.7h-27.1l10.8-23.8h40.8v51c-11.1 12.7-27.2 18.4-46.2 18.4-31.7 0-57.5-25.8-57.5-57.5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.762a128aba578258c31603b580efb171.svg";
export { ForwardRef as ReactComponent };